export const THREAD_FETCH = 'THREAD_FETCH';
export const THREAD_SUCCESS = 'THREAD_SUCCESS';
export const THREAD_FAILURE = 'THREAD_FAILURE';
export const THREAD_RESET = 'THREAD_RESET';

export function requestThread( thread ) {
	return {
		type: THREAD_FETCH,
		thread: thread
	};
}

export function receiveThread( thread, data ) {
	return {
		type: THREAD_SUCCESS,
		thread: thread,
		data: data
	};
}

export function failedThread( thread, error ) {
	return {
		type: THREAD_FAILURE,
		thread: thread,
		error: error
	};
}

export function resetThread() {
	return {
		type: THREAD_RESET
	};
}



// WEBPACK FOOTER //
// ./common/actions/ThreadviewActions.js